import { TProps } from './types/TProps';

export const NavigationToggle = ({ expanded, onClick }: TProps) => (
  <button
    type="button"
    aria-label={expanded ? 'Close menu' : 'Menu'}
    aria-expanded={expanded}
    aria-controls="mobile-navigation"
    onClick={onClick}
    className="inline-flex min-h-11 items-center gap-2 rounded px-2 text-sm font-semibold text-title hover:bg-[var(--color-surface-muted)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-link"
  >
    <svg
      aria-hidden="true"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <path d={expanded ? 'M6 6l12 12M6 18L18 6' : 'M4 6h16M4 12h16M4 18h16'} />
    </svg>
    <span className="hidden sm:inline">{expanded ? 'Close menu' : 'Menu'}</span>
  </button>
);
